module.exports = __webpack_public_path__ + "css/TryStar.e35e76d6.css";